import posthog from 'posthog-js';

export const posthogClient = posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
  api_host: 'https://eu.i.posthog.com',
})!;
